<template>
  <unicom-linha class="linha-embaixo">
    <!-- <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Centro de Oncologia</div>
    </unicom-coluna> -->

    <!-- <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna> -->

    <unicom-coluna sm="4" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Tratamentos Realizados',
          options: listaExames,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="!outrosOpcao && clickSwitch"
    >
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="outrosOpcao && clickSwitch"
    >
      <div align="right" style="font-size: 15px; padding-top: 8px">
        Outros:
      </div>
    </unicom-coluna>
    <unicom-coluna sm="4" :class="espacamentoMobile">
      <unicom-campo-texto
        ladoIcone="direito"
        clickIcone
        :maxCaracteres="1500"
        colorPlaceholder="#9E9E9E"
        placeholder="Outros Procedimentos"
        v-model="payload.outro"
        :mensagemErro="errorsServicos.campoOutrosOncologia"
        v-if="outrosOpcao && clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";

import SharedMixin from "@/views/RecursosPropriosQuestionarios/CentroOncologia/componentes/CartaoInformacoesServicos/components/SharedMixin";
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/CentroOncologia/componentes/CartaoInformacoesServicos/ServicosMixin";

export default {
  mixins: [SharedMixin, ServicosMixin],
  components: {
    Multiselect
  },
  data() {
    return {
      payload: {
        tipoServico: "Centro de Oncologia",
        tipoServicoEspecialidade: [],
        tipoServicoPublico: [],
        outro: ""
      },
      listaExames: [],
      outrosOpcao: false
    };
  },
  beforeMount() {
    this.inicializarExames();
  },
  methods: {
    inicializarExames() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaExames = [...data];
        }
      });
    }
  },
  watch: {
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      // if (newVal.servicos.length > 0) {
      //   newVal.servicos.forEach(servico => {
      //     if (
      //       servico.tipoServico.tipoServico === this.payload.tipoServico &&
      //       (servico.tipoServicoPublico || servico.especialidadesOferecidas)
      //     ) {
      //       this.clickSwitch = true;
      //       this.preencheCampo("publico", servico.tipoServicoPublico);
      //       this.preencheCampo(
      //         "especialidades oferecidas",
      //         servico.especialidadesOferecidas
      //       );
      //       this.emitPayload({
      //         ...this.payload,
      //         clickSwitch: this.clickSwitch
      //       });
      //     }
      //   });
      // }
    }
  }
};
</script>
<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
